<template>
  <label
    :class="{
      'c-checkbox': true,
      'is-valid': state === true || state === 'valid',
      'is-invalid': state === false || state === 'invalid',
      'is-checked': localChecked === value,
      'is-disabled': disabled,
      'is-small': isSmall
    }">
    <input
      type="checkbox"
      ref="check"
      autocomplete="off"
      :aria-required="required ? 'true' : null"
      :disabled="disabled"
      :name="name"
      :required="name && required"
      :value="value"
      v-model="computedLocalChecked"
      @change="handleChange"/>
    <span class="c-checkbox-checker"></span>
    <span class="c-checkbox-content"><slot/></span>
  </label>
</template>
<script>

export default {
  name: 'c-checkbox',
  model: {
    prop: 'checked',
    event: 'input'
  },
  props: {
    checked: {
      type: [Boolean, String, Array]
    },
    disabled: {
      type: Boolean,
      default: false
    },
    isSmall: {
      type: Boolean,
      default: false
    },
    name: {
      type: String,
      default: ''
    },
    required: {
      type: Boolean,
      default: false
    },
    state: {
      type: [Boolean, String],
      default: null,
      validator: (v) => [null, 'valid', 'invalid', true, false].includes(v)
    },
    value: {
      default: true
    },
  },
  data() {
    return {
      localChecked: this.checked
    }
  },
  computed: {
    computedLocalChecked: {
      get() {
        return this.localChecked;
      },
      set(val) {
        this.localChecked = val;
      }
    },
  },
  watch: {
    computedLocalChecked(newVal, oldVal) {
      if (newVal === oldVal) {
        return;
      }

      this.$emit('input', newVal);
    },
    checked(newVal, oldVal) {
      if (newVal === oldVal) {
        return;
      }

      this.computedLocalChecked = newVal;
    },
  },
  methods: {
    handleChange(e) {
      this.$emit('change', e.target.checked ? this.value : null);
    }
  }
}
</script>
